import { render, staticRenderFns } from "./TileNotifications.vue?vue&type=template&id=51b8786c&scoped=true&"
import script from "./TileNotifications.vue?vue&type=script&lang=ts&"
export * from "./TileNotifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8786c",
  null
  
)

export default component.exports